<button
  class="btn-eduid"
  (click)="switchEduIdClick.emit()"
  [disabled]="disabled()"
  pmtLoadingButton
  [loading]="isLoading()"
>
  <img src="/assets/img/logos/switch-edu-id-logo.svg" alt="Login with edu-ID" />
</button>
